import * as types from '../actions/waitlist/types';


const INITIAL_STATE = {
  filters: [],
  optional: {},
  items: [],
};

export default function waitlistReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.FILTER:

      return {
        ...state,
        items: action.payload,
      };

    case types.GET_DISPLAY_PROPERTIES:

      return {
        ...state,
        filters: action.payload.filters,
        optional: action.payload.optional,
      };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/waitlistReducer.js